module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('x-table', [_c('tbody', [
    [_c('tr', [_c('th', {
      staticClass: "detail-page-title",
      attrs: {
        "colspan": "4"
      }
    }, [_c('b', [_vm._v("建设项目信息")])])]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "detail-page-name"
    }, [_vm._v("建业项目名称")]), _vm._v(" "), _c('td', {
      staticClass: "detail-page-text",
      attrs: {
        "colspan": "3"
      }
    }, [_vm._v(_vm._s(_vm.getProperty(_vm.projectInfo, 'refPm.projectName')))])]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "detail-page-name"
    }, [_vm._v("建设项目编号")]), _vm._v(" "), _c('td', {
      staticClass: "detail-page-text"
    }, [_vm._v(_vm._s(_vm.getProperty(_vm.projectInfo, 'refPm.projectNo')))]), _vm._v(" "), _c('td', {
      staticClass: "detail-page-name"
    }, [_vm._v("咨询项目名称")]), _vm._v(" "), _c('td', {
      staticClass: "detail-page-text"
    }, [_vm._v(_vm._s(_vm.getProperty(_vm.projectInfo, 'pm.projectName')))])]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "detail-page-name"
    }, [_vm._v("建设项目所在地")]), _vm._v(" "), _c('td', {
      staticClass: "detail-page-text"
    }, [_c('DictLabel', {
      attrs: {
        "dictKey": 'id',
        "dictLabel": 'name',
        "url": '/region/getparent.do',
        "value": _vm.getProperty(_vm.projectInfo, 'pm.region1Id')
      }
    }), _vm._v("\n          -\n          "), _c('DictLabel', {
      attrs: {
        "dictKey": 'id',
        "dictLabel": 'name',
        "url": ("/region/getChildrens.do?regionId=" + (_vm.getProperty(_vm.projectInfo,'pm.region1Id'))),
        "value": _vm.getProperty(_vm.projectInfo, 'pm.region2Id')
      }
    }), _vm._v("\n          -\n          "), _c('DictLabel', {
      attrs: {
        "dictKey": 'id',
        "dictLabel": 'name',
        "url": ("/region/getChildrens.do?regionId=" + (_vm.getProperty(_vm.projectInfo,'pm.region2Id'))),
        "value": _vm.getProperty(_vm.projectInfo, 'pm.region3Id')
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "detail-page-name"
    }, [_vm._v("咨询项目所处建设项目节点")]), _vm._v(" "), _c('td', {
      staticClass: "detail-page-text"
    }, [_vm._v(_vm._s(_vm.getProperty(_vm.projectInfo, 'pm.region2Id')))])]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "detail-page-name"
    }, [_vm._v("建设性质")]), _vm._v(" "), _c('td', {
      staticClass: "detail-page-text"
    }, [_vm._v(_vm._s(_vm.getProperty(_vm.projectInfo, 'pm.projectType')))]), _vm._v(" "), _c('td', {
      staticClass: "detail-page-name"
    }, [_vm._v("行业属性")]), _vm._v(" "), _c('td', {
      staticClass: "detail-page-text"
    }, [_c('DictLabel', {
      attrs: {
        "dictKey": 'id',
        "dictLabel": 'text',
        "url": '/psubject/listSubjectTree.do',
        "value": _vm.getProperty(_vm.projectInfo, 'pm.subjectId').split(','),
        "isMultiple": true
      }
    })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "detail-page-name"
    }, [_vm._v("建设规模名称")]), _vm._v(" "), _c('td', {
      staticClass: "detail-page-text"
    }, [_vm._v(_vm._s(_vm.getProperty(_vm.projectInfo, 'pm.projectScaleType')))]), _vm._v(" "), _c('td', {
      staticClass: "detail-page-name"
    }, [_vm._v("建设规模数值")]), _vm._v(" "), _c('td', {
      staticClass: "detail-page-text"
    }, [_vm._v(_vm._s(_vm.getProperty(_vm.projectInfo, 'pm.constructionScale')) + "（" + _vm._s(_vm.getProperty(_vm.projectInfo, 'pm.measureUnit')) + "）")])]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "detail-page-name"
    }, [_vm._v("项目批复（计划）总投资（万元）")]), _vm._v(" "), _c('td', {
      staticClass: "detail-page-text"
    }, [_vm._v(_vm._s(_vm.getProperty(_vm.projectInfo, 'pm.approvalTotalInvestment')))]), _vm._v(" "), _c('td', {
      staticClass: "detail-page-name"
    }, [_vm._v("投资性质")]), _vm._v(" "), _c('td', {
      staticClass: "detail-page-text"
    }, [_c('DictLabel', {
      attrs: {
        "dictKey": 'name',
        "dictLabel": 'name',
        "url": '/projectInvestmentNature/listProjectInvestmentNatures.do',
        "value": _vm.getProperty(_vm.projectInfo, 'pm.projectInvestmentNature')
      }
    })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "detail-page-name"
    }, [_vm._v("创建人")]), _vm._v(" "), _c('td', {
      staticClass: "detail-page-text"
    }, [_vm._v(_vm._s(_vm.getProperty(_vm.projectInfo, 'pm.createdBy')))]), _vm._v(" "), _c('td', {
      staticClass: "detail-page-name"
    }, [_vm._v("创建时间")]), _vm._v(" "), _c('td', {
      staticClass: "detail-page-text"
    }, [_vm._v(_vm._s(_vm.getProperty(_vm.projectInfo, 'pm.createdAt')))])])], _vm._v(" "), [_c('tr', [_c('th', {
      staticClass: "detail-page-title",
      attrs: {
        "colspan": "4"
      }
    }, [_c('b', [_vm._v("咨询项目信息")])])]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "detail-page-name"
    }, [_vm._v("咨询项目名称")]), _vm._v(" "), _c('td', {
      staticClass: "detail-page-text"
    }, [_vm._v(_vm._s(_vm.getProperty(_vm.costInfo, 'cost.name')))]), _vm._v(" "), _c('td', {
      staticClass: "detail-page-name"
    }, [_vm._v("咨询项目编号")]), _vm._v(" "), _c('td', {
      staticClass: "detail-page-text"
    }, [_vm._v(_vm._s(_vm.getProperty(_vm.costInfo, 'cost.no')))])]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "detail-page-name"
    }, [_vm._v("业务类型")]), _vm._v(" "), _c('td', {
      staticClass: "detail-page-text"
    }, [_c('DictLabel', {
      attrs: {
        "dictKey": 'id',
        "dictLabel": 'name',
        "url": ("/entrust/listValidEntrustByFlowId.do?flowId=" + (_vm.getProperty(_vm.costInfo,'flow.flowId'))),
        "value": _vm.getProperty(_vm.costInfo, 'cost.entrustId')
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "detail-page-name"
    }, [_vm._v("业务类别")]), _vm._v(" "), _c('td', {
      staticClass: "detail-page-text"
    }, [_vm._v(_vm._s(_vm.getProperty(_vm.costInfo, 'cost.businessCategoryName')))])]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "detail-page-name"
    }, [_vm._v("委托业务对应的项目属性")]), _vm._v(" "), _c('td', {
      staticClass: "detail-page-text"
    }, [_c('DictLabel', {
      attrs: {
        "dictKey": 'id',
        "dictLabel": 'text',
        "url": ("/psubject/listSubjectTreeByIdsAscombobox.do?subjectIds=" + (_vm.getProperty(_vm.costInfo,'proInfo.subjectId'))),
        "value": _vm.getProperty(_vm.costInfo, 'cost.subjectProproty').split(','),
        "isMultiple": true
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "detail-page-name"
    }, [_vm._v("委托业务所对应的工程内容")]), _vm._v(" "), _c('td', {
      staticClass: "detail-page-text"
    }, [_c('DictLabel', {
      attrs: {
        "dictKey": 'id',
        "dictLabel": 'text',
        "url": ("/psubject/listSubjectTreeByIdsAscombobox.do?subjectIds=" + (_vm.getProperty(_vm.costInfo,'cost.subjectProproty'))),
        "value": _vm.getProperty(_vm.costInfo, 'cost.subjectProprotyDetail').split(','),
        "isMultiple": true
      }
    })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "detail-page-name"
    }, [_vm._v("实际开工时间")]), _vm._v(" "), _c('td', {
      staticClass: "detail-page-text"
    }, [_vm._v(_vm._s(_vm.getProperty(_vm.costInfo, 'cost.actualBeginDate')))]), _vm._v(" "), _c('td', {
      staticClass: "detail-page-name"
    }, [_vm._v("实际竣工时间")]), _vm._v(" "), _c('td', {
      staticClass: "detail-page-text"
    }, [_vm._v(_vm._s(_vm.getProperty(_vm.costInfo, 'cost.actualEndDate')))])]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "detail-page-name"
    }, [_vm._v("框架协议合同编号")]), _vm._v(" "), _c('td', {
      staticClass: "detail-page-text"
    }, [_vm._v(_vm._s(_vm.getProperty(_vm.costInfo, 'cost.contractNo')))]), _vm._v(" "), _c('td', {
      staticClass: "detail-page-name"
    }, [_vm._v("所属框架协议")]), _vm._v(" "), _c('td', {
      staticClass: "detail-page-text"
    }, [_vm._v(_vm._s(_vm.getProperty(_vm.costInfo, 'cost.contractName')))])]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "detail-page-name"
    }, [_vm._v("登记人")]), _vm._v(" "), _c('td', {
      staticClass: "detail-page-text"
    }, [_vm._v(_vm._s(_vm.getProperty(_vm.costInfo, 'cost.registerStaffName')))]), _vm._v(" "), _c('td', {
      staticClass: "detail-page-name"
    }, [_vm._v("登记日期")]), _vm._v(" "), _c('td', {
      staticClass: "detail-page-text"
    }, [_vm._v(_vm._s(_vm.getProperty(_vm.costInfo, 'cost.registerDate')))])])], _vm._v(" "), [_c('tr', [_c('th', {
      staticClass: "detail-page-title",
      attrs: {
        "colspan": "4"
      }
    }, [_c('b', [_vm._v("安排业务科室")])])]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "detail-page-name"
    }, [_vm._v("业务登记人")]), _vm._v(" "), _c('td', {
      staticClass: "detail-page-text"
    }, [_vm._v(_vm._s(_vm.getProperty(_vm.arrangeDepartmentInfo, 'regUser.name')))]), _vm._v(" "), _c('td', {
      staticClass: "detail-page-name"
    }, [_vm._v("登记人部门")]), _vm._v(" "), _c('td', {
      staticClass: "detail-page-text"
    }, [_vm._v(_vm._s(_vm.getProperty(_vm.arrangeDepartmentInfo, 'regUser.regOrgName')))])]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "detail-page-name"
    }, [_vm._v("登记时间")]), _vm._v(" "), _c('td', {
      staticClass: "detail-page-text"
    }, [_vm._v(_vm._s(_vm.getProperty(_vm.arrangeDepartmentInfo, 'task.beginDate')))]), _vm._v(" "), _c('td', {
      staticClass: "detail-page-name"
    }, [_vm._v("安排时间")]), _vm._v(" "), _c('td', {
      staticClass: "detail-page-text"
    }, [_vm._v(_vm._s(_vm.getProperty(_vm.arrangeDepartmentInfo, 'cost.arrangeDate')))])]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "detail-page-name"
    }, [_vm._v("分管领导")]), _vm._v(" "), _c('td', {
      staticClass: "detail-page-text"
    }, [_vm._v(_vm._s(_vm.getProperty(_vm.arrangeDepartmentInfo, 'cost.chargerName')))]), _vm._v(" "), _c('td', {
      staticClass: "detail-page-name"
    }, [_vm._v("主办部门负责人")]), _vm._v(" "), _c('td', {
      staticClass: "detail-page-text"
    }, [_vm._v(_vm._s(_vm.getProperty(_vm.arrangeDepartmentInfo, 'cost.leaderName')))])]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "detail-page-name"
    }, [_vm._v("主办部门")]), _vm._v(" "), _c('td', {
      staticClass: "detail-page-text"
    }, [_vm._v(_vm._s(_vm.getProperty(_vm.arrangeDepartmentInfo, 'cost.departmentName')))]), _vm._v(" "), _c('td', {
      staticClass: "detail-page-name"
    }, [_vm._v("主办人（项目负责人）")]), _vm._v(" "), _c('td', {
      staticClass: "detail-page-text"
    }, [_vm._v(_vm._s(_vm.getProperty(_vm.arrangeDepartmentInfo, 'cost.managerName')))])]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "detail-page-name"
    }, [_vm._v("责任督导员")]), _vm._v(" "), _c('td', {
      staticClass: "detail-page-text"
    }, [_vm._v(_vm._s(_vm.getProperty(_vm.arrangeDepartmentInfo, 'cost.responsibleSupervisorName')))]), _vm._v(" "), _c('td', {
      staticClass: "detail-page-name"
    }, [_vm._v("项目组成员")]), _vm._v(" "), _c('td', {
      staticClass: "detail-page-text"
    }, [_vm._v(_vm._s(_vm.getProperty(_vm.arrangeDepartmentInfo, 'cost.projectMemberNames')))])])], _vm._v(" "), _vm._l((_vm.costWorkFilesInfo), function(item) {
      return [_c('tr', [_c('th', {
        staticClass: "detail-page-title",
        attrs: {
          "colspan": "4"
        }
      }, [_c('b', [_vm._v(_vm._s(item.name))])])]), _vm._v(" "), _c('tr', [_c('td', {
        staticClass: "detail-page-name"
      }, [_vm._v("文件类型")]), _vm._v(" "), _c('td', {
        staticClass: "detail-page-text"
      }, [_vm._v(_vm._s(item.typeNames))]), _vm._v(" "), _c('td', {
        staticClass: "detail-page-name"
      }, [_vm._v("送审金额(元)")]), _vm._v(" "), _c('td', {
        staticClass: "detail-page-text",
        class: {
          'input-can': item['submittedCost_can']
        }
      }, [(item['submittedCost_can']) ? [_c('x-input', {
        attrs: {
          "type": "number",
          "show-clear": false
        },
        on: {
          "on-blur": function($event) {
            _vm.updateCostWorkCost(item.id, 'submittedCost', item.submittedCost)
          }
        },
        model: {
          value: (item.submittedCost),
          callback: function($$v) {
            _vm.$set(item, "submittedCost", $$v)
          },
          expression: "item.submittedCost"
        }
      })] : [_vm._v(_vm._s(item.submittedCost))]], 2)]), _vm._v(" "), _c('tr', [_c('td', {
        staticClass: "detail-page-name"
      }, [_vm._v("经办人申报金额(元)")]), _vm._v(" "), _c('td', {
        staticClass: "detail-page-text",
        class: {
          'input-can': item['auditedCost_can']
        }
      }, [(item['auditedCost_can']) ? [_c('x-input', {
        attrs: {
          "type": "number",
          "show-clear": false
        },
        on: {
          "on-blur": function($event) {
            _vm.updateCostWorkCost(item.id, 'auditedCost', item.auditedCost)
          }
        },
        model: {
          value: (item.auditedCost),
          callback: function($$v) {
            _vm.$set(item, "auditedCost", $$v)
          },
          expression: "item.auditedCost"
        }
      })] : [_vm._v(_vm._s(item.auditedCost))]], 2), _vm._v(" "), _c('td', {
        staticClass: "detail-page-name"
      }, [_vm._v("项目负责人稽核金额(元)")]), _vm._v(" "), _c('td', {
        staticClass: "detail-page-text",
        class: {
          'input-can': item['auditedCost1_can']
        }
      }, [(item['auditedCost1_can']) ? [_c('x-input', {
        attrs: {
          "type": "number",
          "show-clear": false
        },
        on: {
          "on-blur": function($event) {
            _vm.updateCostWorkCost(item.id, 'auditedCost1', item.auditedCost1)
          }
        },
        model: {
          value: (item.auditedCost1),
          callback: function($$v) {
            _vm.$set(item, "auditedCost1", $$v)
          },
          expression: "item.auditedCost1"
        }
      })] : [_vm._v(_vm._s(item.auditedCost1))]], 2)]), _vm._v(" "), _c('tr', [_c('td', {
        staticClass: "detail-page-name"
      }, [_vm._v("业务部门稽核金额(元)")]), _vm._v(" "), _c('td', {
        staticClass: "detail-page-text",
        class: {
          'input-can': item['auditedCost2_can']
        }
      }, [(item['auditedCost2_can']) ? [_c('x-input', {
        attrs: {
          "type": "number",
          "show-clear": false
        },
        on: {
          "on-blur": function($event) {
            _vm.updateCostWorkCost(item.id, 'auditedCost2', item.auditedCost2)
          }
        },
        model: {
          value: (item.auditedCost2),
          callback: function($$v) {
            _vm.$set(item, "auditedCost2", $$v)
          },
          expression: "item.auditedCost2"
        }
      })] : [_vm._v(_vm._s(item.auditedCost2))]], 2), _vm._v(" "), _c('td', {
        staticClass: "detail-page-name"
      }, [_vm._v("质管部稽核金额(元)")]), _vm._v(" "), _c('td', {
        staticClass: "detail-page-text",
        class: {
          'input-can': item['auditedCost3_can']
        }
      }, [(item['auditedCost3_can']) ? [_c('x-input', {
        attrs: {
          "type": "number",
          "show-clear": false
        },
        on: {
          "on-blur": function($event) {
            _vm.updateCostWorkCost(item.id, 'auditedCost3', item.auditedCost3)
          }
        },
        model: {
          value: (item.auditedCost3),
          callback: function($$v) {
            _vm.$set(item, "auditedCost3", $$v)
          },
          expression: "item.auditedCost3"
        }
      })] : [_vm._v(_vm._s(item.auditedCost3))]], 2)]), _vm._v(" "), _c('tr', [_c('td', {
        staticClass: "detail-page-name"
      }, [_vm._v("分管领导审批金额(元)")]), _vm._v(" "), _c('td', {
        staticClass: "detail-page-text",
        class: {
          'input-can': item['approvedCost_can']
        }
      }, [(item['approvedCost_can']) ? [_c('x-input', {
        attrs: {
          "type": "number",
          "show-clear": false
        },
        on: {
          "on-blur": function($event) {
            _vm.updateCostWorkCost(item.id, 'approvedCost', item.approvedCost)
          }
        },
        model: {
          value: (item.approvedCost),
          callback: function($$v) {
            _vm.$set(item, "approvedCost", $$v)
          },
          expression: "item.approvedCost"
        }
      })] : [_vm._v(_vm._s(item.approvedCost))]], 2), _vm._v(" "), _c('td', {
        staticClass: "detail-page-name"
      }, [_vm._v("质量评分偏差调整金额(元)")]), _vm._v(" "), _c('td', {
        staticClass: "detail-page-text",
        class: {
          'input-can': item['deviation2_can']
        }
      }, [(item['deviation2_can']) ? [_c('x-input', {
        attrs: {
          "type": "number",
          "show-clear": false
        },
        on: {
          "on-blur": function($event) {
            _vm.updateCostWorkCost(item.id, 'deviation2', item.deviation2)
          }
        },
        model: {
          value: (item.deviation2),
          callback: function($$v) {
            _vm.$set(item, "deviation2", $$v)
          },
          expression: "item.deviation2"
        }
      })] : [_vm._v(_vm._s(item.deviation2))]], 2)]), _vm._v(" "), _c('tr', [_c('td', {
        staticClass: "detail-page-name"
      }, [_vm._v("质量评分偏差金额(元)")]), _vm._v(" "), _c('td', {
        staticClass: "detail-page-text",
        class: {
          'input-can': item['deviation_can']
        }
      }, [(item['deviation_can']) ? [_c('x-input', {
        attrs: {
          "type": "number",
          "show-clear": false
        },
        on: {
          "on-blur": function($event) {
            _vm.updateCostWorkCost(item.id, 'deviation', item.deviation)
          }
        },
        model: {
          value: (item.deviation),
          callback: function($$v) {
            _vm.$set(item, "deviation", $$v)
          },
          expression: "item.deviation"
        }
      })] : [_vm._v(_vm._s(item.deviation))]], 2), _vm._v(" "), _c('td', {
        staticClass: "detail-page-name"
      }, [_vm._v("评分")]), _vm._v(" "), _c('td', {
        staticClass: "detail-page-text"
      }, [_vm._v(_vm._s(item.score))])]), _vm._v(" "), _c('tr', [_c('td', {
        staticClass: "detail-page-name"
      }, [_vm._v("综合评分")]), _vm._v(" "), _c('td', {
        staticClass: "detail-page-text"
      }, [_vm._v(_vm._s(item.scoreTotal))]), _vm._v(" "), _c('td', {
        staticClass: "detail-page-name"
      }, [_vm._v("总评分")]), _vm._v(" "), _c('td', {
        staticClass: "detail-page-text"
      }, [_vm._v(_vm._s(item.scoreSum))])]), _vm._v(" "), _c('tr', [_c('td', {
        staticClass: "detail-page-name"
      }, [_vm._v("偏差情况简述")]), _vm._v(" "), _c('td', {
        staticClass: "detail-page-text"
      }, [_vm._v(_vm._s(item.deviationDescription))]), _vm._v(" "), _c('td', {
        staticClass: "detail-page-name"
      }, [_vm._v("偏差原因简述")]), _vm._v(" "), _c('td', {
        staticClass: "detail-page-text"
      }, [_vm._v(_vm._s(item.deviationCauses))])]), _vm._v(" "), _c('tr', [_c('td', {
        staticClass: "detail-page-name"
      }, [_vm._v("实际签批督导员")]), _vm._v(" "), _c('td', {
        staticClass: "detail-page-text"
      }, [_vm._v(_vm._s(item.realSupervisorName))]), _vm._v(" "), _c('td', {
        staticClass: "detail-page-name"
      }, [_vm._v("成果文件编制时间")]), _vm._v(" "), _c('td', {
        staticClass: "detail-page-text"
      })]), _vm._v(" "), _c('tr', [_c('td', {
        staticClass: "detail-page-name"
      }, [_vm._v("签字造价师")]), _vm._v(" "), _c('td', {
        staticClass: "detail-page-text"
      }, [_vm._v(_vm._s(item.signedCostName))]), _vm._v(" "), _c('td', {
        staticClass: "detail-page-name"
      }, [_vm._v("建设规模名称")]), _vm._v(" "), _c('td', {
        staticClass: "detail-page-text"
      }, [_vm._v(_vm._s(item.projectScaleType))])]), _vm._v(" "), _c('tr', [_c('td', {
        staticClass: "detail-page-name"
      }, [_vm._v("建设规模数值")]), _vm._v(" "), _c('td', {
        staticClass: "detail-page-text"
      }, [_vm._v(_vm._s(item.constructionScale) + "（" + _vm._s(item.measureUnit) + "）")]), _vm._v(" "), _c('td', {
        staticClass: "detail-page-name"
      }, [_vm._v("是否冻结")]), _vm._v(" "), _c('td', {
        staticClass: "detail-page-text"
      }, [_vm._v(_vm._s(item.frozenStr))])]), _vm._v(" "), (Array.isArray(_vm.getProperty(item, 'files'))) ? [_c('tr', [_c('td', {
        staticClass: "detail-page-name"
      }, [_vm._v("附件")]), _vm._v(" "), _c('td', {
        staticClass: "detail-page-text",
        attrs: {
          "colspan": "4"
        }
      }, [_vm._l((_vm.getProperty(item, 'files')), function(file) {
        return [_c('a', {
          attrs: {
            "href": ("/wechat/commonFile/downloadForStream?fileId=" + (file.id) + "&flowId=" + (_vm.idArr[1]) + "&stepId=" + (_vm.idArr[2]))
          }
        }, [_vm._v(_vm._s(file.name))]), _vm._v(" "), _c('br')]
      })], 2)])] : _vm._e()]
    })
  ], 2)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0bf35c83","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/detail/todo/business/cost/approval.vue
// module id = iMCC
// module chunks = 1